export default __webpack_public_path__ + "static/Singapore International Water Week-a0e593b5bd0236f95e36675cb8944825.png";